import { render, staticRenderFns } from "./ChatWidget.vue?vue&type=template&id=01992dad&scoped=true"
import script from "./ChatWidget.vue?vue&type=script&lang=js"
export * from "./ChatWidget.vue?vue&type=script&lang=js"
import style0 from "./ChatWidget.vue?vue&type=style&index=0&id=01992dad&prod&lang=scss&scoped=true"
import style1 from "./ChatWidget.vue?vue&type=style&index=1&id=01992dad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../amenities/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01992dad",
  null
  
)

export default component.exports